import css from 'styled-jsx/css';
import { colors, screen } from 'components/styles/variables';

export const styles = css`
  .close-button {
    background: none;
    border: none;
    padding: 0;
    position: fixed;
    top: 12px;
    right: 16px;
    height: 15px;
  }
  .close-button img {
    height: 15px;
    width: 15px;
    position: relative;
  }
  .border {
    border-top: 1px solid ${colors.G2};
    border-bottom: 0;
    padding: 0;
    position: fixed;
    left: -15px;
    width: calc(100% + 32px);
    top: 98px;
  }
  .quick-view-container {
    margin: 0 16px;
    height: 100%;
  }
  .detail-container {
    height: 100%;
    overflow: scroll;
    margin-top: 175px;
  }
  .header-container {
    padding-top: 44px;
    background: white;
    width: 100%;
    position: fixed;
  }
  .listing-card-container {
    position: absolute;
    margin-right: 16px;
  }
  .listing-card {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 16px;
    gap: 16px;
    border: 1px solid #d3d3d3;
    box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    margin-bottom: 24px;
    background: ${colors.WHITE};
    position: fixed;
    z-index: 10;
    justify-content: space-between;
    width: calc(100vw - 32px);
  }
  .listing-vehicle-details {
    display: flex;
    align-items: center;
    gap: 16px;
  }
  .make-model,
  .price {
    color: ${colors.BLACK};
    font-weight: 700;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: 0.2px;
  }
  .make-model {
    margin-bottom: 4px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .est-payment {
    color: ${colors.G3};
    font-weight: 400;
    margin-left: 6px;
    font-size: 14px;
  }
  .section-header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;
  }
  .section-title {
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.2px;
    text-transform: uppercase;
  }
  .view-more {
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.2px;
    color: ${colors.ALR1};
  }
  .view-more:hover {
    cursor: pointer;
  }
  .view-more-arrow {
    margin-left: 6px;
  }
  .detail-row,
  .information-row {
    display: flex;
    justify-content: space-between;
  }
  .information-row {
    flex-direction: column;
  }
  .detail-section {
    display: flex;
    align-items: center;
    gap: 12px;
    height: 66px;
    width: 163px;
  }
  .detail-title {
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.2px;
    margin-bottom: 1px;
    color: ${colors.BLACK};
  }
  .detail-content {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.2px;
    color: ${colors.BLACK};
  }
  .vehicle-information {
    border-top: 1px solid ${colors.G2};
    padding-top: 16px;
    margin-top: 16px;
  }
  .information-section {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: auto;
    height: 32px;
  }
  .information-title {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.2px;
    color: ${colors.BLACK};
  }
  .information-content {
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.2px;
    color: ${colors.BLACK};
  }
  .transmission,
  .fuel-type {
    text-transform: capitalize;
  }

  @media (min-width: ${screen.smMin}) {
    .header-container {
      position: initial;
    }
    .listing-card-container {
      position: relative;
      margin-right: 0;
    }
    .close-button {
      position: absolute;
    }
    .border {
      left: 0;
      position: absolute;
      width: 100%;
    }
    .listing-card {
      padding: 20px 24px;
      width: initial;
      position: relative;
    }
    .detail-section {
      width: 241px;
    }
    .information-row {
      flex-direction: row;
    }
    .information-section {
      width: 200px;
    }
    .detail-container {
      overflow: auto;
      margin-top: 0;
    }
  }
  @media (min-width: 850px) {
    .quick-view-container {
      margin: 0;
    }
    .header-container {
      width: auto;
      padding-top: 0;
    }
  }
`;
